export const ALLOW_PROCEED_INVESTMENT = 'ALLOW_PROCEED_INVESTMENT'
export const allowProceedInvestment = () => ({ type: 'ALLOW_PROCEED_INVESTMENT' })

export const RESET_INVESTMENT_PERMISSION = 'RESET_INVESTMENT_PERMISSION'
export const resetInvestmentPermission = () => ({ type: 'RESET_INVESTMENT_PERMISSION' })

export const REJECT_INVESTMENT_PERMISSION = 'REJECT_INVESTMENT_PERMISSION'
export const rejectInvestmentPermission = (permissionResult) => ({
  type: 'REJECT_INVESTMENT_PERMISSION',
  payload: permissionResult,
})

export const VALIDATING_SALE_PERMISSION = 'VALIDATING_SALE_PERMISSION'
export const validatingSalePermission = () => ({
  type: 'VALIDATING_SALE_PERMISSION',
})

export const SALE_PERMISSION_VALIDATION_COMPLETED = 'SALE_PERMISSION_VALIDATION_COMPLETED'
export const salePermissionValidationCompleted = () => ({
  type: 'SALE_PERMISSION_VALIDATION_COMPLETED',
})
